import { Button, IButtonProps } from './Button';

interface IProps extends IButtonProps {
  isSaving?: boolean;
  savingLabel?: string;
  className?: string;
}

export const SaveButton = ({
  disabled = false,
  isSaving = false,
  children,
  savingLabel = 'Saving...',
  className = '',
  ...rest
}: IProps) => {
  // TODO: remove the bg-deep-sea from the below className property once all the pages are converted to Next.js
  return (
    <Button className={`bg-deep-sea ${className}`} disabled={isSaving || disabled} {...rest}>
      {isSaving ? savingLabel : children}
    </Button>
  );
};
